export default __webpack_public_path__ + "static/media/BatteryMaintenance3.3501e7d8.png";